<template>
  <div class="wrapper">
    <div class="tabs">
      <div
        class="tab"
        v-for="(item,i) in tabs"
        :key="i"
        @click="contentIndex=i"
        :class="contentIndex==i?'active':''"
      >{{item}}</div>
    </div>
    <div class="main" v-show="contentIndex==0">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item :label="$t('oldPwd')" prop="oldPass">
          <el-input v-model="ruleForm.oldPass" maxlength="16" minlength="6" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('newPwd')" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('submitPwd')" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"  show-password></el-input>
        </el-form-item>
        <div class="post-btn" @click="submitForm('ruleForm')">{{$t('save')}}</div>
		<div style="padding-top:30px;">If you forget the old password,</div> 
		<div style="padding-top:10px;">Please contact us: info@sanlidaarchery.com</div>
      </el-form>
    </div>
    <div class="main" v-show="contentIndex==1">
      <el-form
        :model="ruleForm1"
        status-icon
        :rules="rules"
        ref="ruleForm1"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item :label="$t('email')" >
          <el-input v-model="ruleForm1.mobile" ></el-input>
        </el-form-item>
        <!-- <div class="codeInput-wrap">
          <el-form-item :label="$t('verificationCode')" prop="code" class="codeInput">
            <el-input type="text" autocomplete="off" v-model.number="ruleForm1.code"></el-input>
          </el-form-item>
          <div class="code-btn" @click="sendCode" v-show="verification">send</div>
          <div class="code-btn not" v-show="!verification">{{$t('toSend')}}({{timer}})</div>
        </div> -->

        <el-form-item :label="$t('newPwd')" prop="pass1">
          <el-input type="password" v-model="ruleForm1.pass1" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('submitPwd')" prop="checkPass1">
          <el-input type="password" v-model="ruleForm1.checkPass1" autocomplete="off"></el-input>
        </el-form-item>
        <div class="post-btn" @click="submitForm1('ruleForm1')">{{$t('save')}}</div>
      </el-form>
    </div>
  </div>
</template>

<script>
// import InputGroup from "@/components/layout/InputGroup.vue";
import { inputCheckPhone } from "@/utils";
export default {
  name: "SafeCenter",
  // components: { InputGroup },
  props: {},
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('error', {prefix: this.$t('newPwd')})));
      }
      callback();
    };
    var validateFormPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('pEnterPwd')));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validateFormPass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('pAgainEnterPwd')));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(this.$t('pwdCheck')));
      } else {
        callback();
      }
    };
    var validateForm1Pass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('pEnterPwd')));
      } else {
        if (this.ruleForm1.checkPass1 !== "") {
          this.$refs.ruleForm1.validateField("checkPass1");
        }
        callback();
      }
    };
    var validateForm1Pass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('pAgainEnterPwd')));
      } else if (value !== this.ruleForm1.pass1) {
        callback(new Error(this.$t('pwdCheck')));
      } else {
        callback();
      }
    };
    var checkMobile = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error(this.$t('pEenterPhoneNumber')));
      } else if (!inputCheckPhone(value)) {
        return callback(new Error(this.$t('mobileError')));
      }
      callback();
    };
    return {
      verification: true,
      sendText: this.$t('getVerificationCode'),
      timer: 60,
      auth_timer: "",
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: ""
      },
      ruleForm1: {
        mobile: "",
        code: "",
        pass1: "",
        checkPass1: ""
      },
      rules: {
        pass: [{ validator: validateFormPass, trigger: "blur" }],
        checkPass: [{ validator: validateFormPass2, trigger: "blur" }],
        pass1: [{ validator: validateForm1Pass, trigger: "blur" }],
        checkPass1: [{ validator: validateForm1Pass2, trigger: "blur" }],
        oldPass: [{ validator: checkOldPass, trigger: "blur" }],
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        code: [{ required: true, message: this.$t('enter', {text: this.$t('verificationCode')}), trigger: "blur" }]
      },
      tabs: ['Reset Password'],
      contentIndex: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    sendCode() {
      if (!this.ruleForm1.mobile || !inputCheckPhone(this.ruleForm1.mobile)) {
        return this.$msg(this.$t('error', {prefix: this.$t('mobile')}), "warning");
      } else {
        this.$api
          .sms({ mobile: this.ruleForm1.mobile, code: "veri" })
          .then(res => {
            if (res.status) {
              this.verification = false;
              this.countDown(); // 执行验证码计时
            } else {
              this.$msg(res.msg, "error");
            }
          });
      }
    },
    countDown() {
      let auth_timer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.verification = true; 
          this.timer = 60;
          clearInterval(auth_timer);
          this.sendText = this.$t('toSend');
        }
      }, 1000);
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editPass();
        } else {
          return false;
        }
      });
    },
    submitForm1(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.resetPass();
        } else {
          return false;
        }
      });
    },
    resetPass() {
      let data = {
        mobile: this.ruleForm1.mobile,
        // code: this.ruleForm1.code,
        newpwd: this.ruleForm1.pass1,
        repwd: this.ruleForm1.checkPass1
      };
      this.$api.forgotPwd(data).then(res => {
        this.resultStatus(res);
      });
    },
    editPass() {
      let data = {
        pwd: this.ruleForm.oldPass,
        newpwd: this.ruleForm.checkPass,//新密码
        repwd: this.ruleForm.pass//新密码
      };
      this.$api.editPwd(data).then(res => {
        this.resultStatus(res);
      });
    },
    resultStatus(res) {
      if (res.status) {
        this.$msg(this.$t('reLogin'), "warning");
        this.$storage.remove("userToken");
        this.$router.replace({ name: "login" });
      } else {
        this.$msg(res.msg, "error");
      }
    }
  },
  created() {},
  mounted() {},
  destroyed() {
    clearInterval(this.auth_timer);
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  height: 600px;
  .tabs {
    display: flex;
    padding: 15px 0;
    .tab {
      padding: 0 20px;
      cursor: pointer;
      &:not(:last-of-type) {
        border-right: 1px solid $border;
      }
      &.active {
        color: $theme-color;
      }
      &:first-child {
        padding-left: 0;
      }
    }
  }
  .main {
    width: 300px;
    margin-top: 20px;
  }
}
.codeInput-wrap {
  display: flex;
  position: relative;
  .codeInput {
    width: 216px;
  }
  .code-btn {
    position: absolute;
    top: 50px;
    right: 0;
    width: 84px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ea4b49;
    font-weight: 400;
    border: 1px solid #dcdfe6;
    border-left: none;
    cursor: pointer;
    z-index: 999;
    &.not {
      color: #999;
    }
  }
}
.post-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  border-radius: none;
  background: $theme-color;
  cursor: pointer;
}
</style>